import { z, type ZodType } from 'zod';

/** The Responses API `text.format` that makes the model reply with JSON matching a schema. */
export interface JsonSchemaFormat {
  type: 'json_schema';
  name: string;
  schema: Record<string, unknown>;
  strict: true;
}

/**
 * The strict `text.format` for a reply matching `schema`. Zod's JSON Schema closes
 * every object and lists every property as required, which strict mode demands, and
 * carries each `.describe()` text to the model as the field's description. The
 * `$schema` dialect marker is dropped because the format takes the schema body only.
 */
export function jsonSchemaFormat(name: string, schema: ZodType): JsonSchemaFormat {
  const body: Record<string, unknown> = { ...z.toJSONSchema(schema) };
  delete body.$schema;
  return { type: 'json_schema', name, schema: body, strict: true };
}
